<template>
  <div>
    <vs-popup :title="marketplaceData.title" :active.sync="detailsPopupActive">
      <div>
        <div class="flex items-start">
            <span
                class="template-options-btn-icon p-4 inline-flex feather-icon text-primary mr-3"
                :style="{'background': marketplaceData.color, 'border-radius': '10px'}"
            >
                <img
                    :src="marketplaceData.icon"
                    width="28px"
                    height="28px"
                />
            </span>
            <div class="relative m-1">
                <h4 class="mb-1">{{ marketplaceData.title }}</h4>
                <p>{{ marketplaceData.shortDescription }}</p>
            </div>
        </div>
        <vs-divider />
        <div>
            <p v-html="marketplaceData.description"></p>
        </div>
        <vs-divider />
        <div v-if="marketplaceData.ss1">
            <img :src="marketplaceData.ss1" width="50%" />
        </div>
      </div>
    </vs-popup>
    <div class="marketplace--item p-5 cursor-pointer" @click.stop="detailsPopupActive=true">
      <div class="vx-row flex justify-between flex-wrap mb-5">
        <div class="vx-col">
          <span
            class="template-options-btn-icon p-2 inline-flex feather-icon text-primary mr-3"
            :style="{'background': marketplaceData.color, 'border-radius': '10px'}"
          >
            <img
              :src="marketplaceData.icon"
              width="28px"
              height="28px"
            />
          </span>
        </div>
        <div class="vx-col">
          <!-- <vs-button color="#44CC88" type="filled" @click.stop="detailsPopupActive=true">Get</vs-button> -->
        </div>
      </div>
      <h4 class="mb-1">{{marketplaceData.title}}</h4>
      <p v-if="marketplaceData.shortDescription && marketplaceData.shortDescription.length < 80" class="wrap-text">{{marketplaceData.shortDescription}}</p>
      <p v-else-if="marketplaceData.shortDescription && marketplaceData.shortDescription.length > 80">{{marketplaceData.shortDescription.substring(0, 80)}}...</p>
      <p v-else class="wrap-text">Lorem ipsum dolor sit amet consetetur...</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['marketplaceData'],
  data() {
    return {
      detailsPopupActive: false
    }
  }
};
</script>

<style scoped>
.marketplace--item {
  background: #ffffff;
  border: 1px solid #e8edf1;
  box-sizing: border-box;
  border-radius: 6px;
  /* min-height: 185px; */
}

.marketplace--item:hover {        
        background: #FFFDF7!important;
        border: 1px solid rgba(242, 194, 68, 0.35)!important;
        box-shadow: 0px 8px 40px rgba(242, 194, 68, 0.05);
        transition: none;
}

@media only screen and (max-width: 1200px) {
  .marketplace--item {
    min-height: 185px;
  }
}
</style>